function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M10.5 16h3c2.5 0 4-1.8 4-4V6.91c0-1.05-.86-1.91-1.91-1.91H8.42c-1.05 0-1.91.86-1.91 1.91V12C6.5 14.2 8 16 10.5 16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.25 2v3h-1.5V2c0-.41.34-.75.75-.75s.75.34.75.75zm5 0v3h-1.5V2c0-.41.34-.75.75-.75s.75.34.75.75zm-2.5 14v6c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-6h1.5z"
})));